import React from "react";
import GalleryCard from "../components/GalleryCard";
import Title from "../components/Title";
import abstracts from "../images/Paintings/Abstracts/sm/0_previewAbstracts.jpg";
import HeaderSpacer from "../components/HeaderSpacer";
import cityscapes from "../images/Paintings/Cityscapes/sm/0_previewCityscapes.jpg";
import interiors from "../images/Paintings/Interiors/sm/0_previewImageInteriors.jpg";
import misc from "../images/Paintings/misc/sm/0_previewImageMisc.jpg";
import peoplescapesNew from "../images/Paintings/Peoplescapes_2024-now/sm/0_preview2025.jpg";
import timeMachine from "../images/Paintings/TimeMachine_2025/sm/0_timeMachine2025.jpg";
import peoplescapes2023 from "../images/Paintings/Peoplescapes_2018-2023/sm/0_previewImageP2018.jpg";
import peoplescapesOld from "../images/Paintings/Peoplescapes_2007-2017/sm/0_previewImageP2007.jpg";
import FloatingSubtitle from "../components/FloatingSubtitle";
import UpButton from "../components/UpButton";
import { Helmet } from "react-helmet-async";
import returnYear from "../utils/GetYear";

function Paintings() {
  return (
    <div>
      <Helmet>
        <title>Tyrone Layne | Paintings</title>
        <meta property='og:image' content={peoplescapesNew} />
        <link rel='canonical' href='https://tyronelayne.com/paintings' />
      </Helmet>
      <Title subtitle='Paintings' />
      <FloatingSubtitle text='paintings' extraCSS='paintingTitle' />
      <HeaderSpacer />

      <div className='galleryGrid'>
        <GalleryCard
          source={peoplescapesNew}
          description={`Click to view Peoplescapes 2024 - ${returnYear()} gallery.`}
          linkTo='/paintings/peoplescapes-new'
          label={`Peoplescapes 2024 - ${returnYear()}`}
        />
        <GalleryCard
          source={timeMachine}
          description='Click to view TIME MACHINE- 2025 gallery.'
          linkTo='/paintings/timemachine-2025'
          label='Time Machine 2025'
        />
        <GalleryCard
          source={peoplescapes2023}
          description='Click to view Peoplescapes 2018 - 2023 gallery.'
          linkTo='/paintings/peoplescapes-2023'
          label='Peoplescapes 2018 - 2023'
        />
        <GalleryCard
          source={peoplescapesOld}
          description='Click to view Peoplescapes 2007 - 2017 gallery.'
          linkTo='/paintings/peoplescapes-old'
          label='Peoplescapes 2007 - 2017'
        />
        <GalleryCard
          source={abstracts}
          description='Click to view Abstracts gallery.'
          linkTo='/paintings/abstracts'
          label='Abstracts'
        />
        <GalleryCard
          source={cityscapes}
          description='Click to view Cityscapes gallery.'
          linkTo='/paintings/cityscapes'
          label='Cityscapes'
        />
        <GalleryCard
          source={interiors}
          description='Click to view Interiors gallery.'
          linkTo='/paintings/interiors'
          label='Interiors'
        />
        <GalleryCard
          source={misc}
          description='Click to view Miscellaneous gallery.'
          linkTo='/paintings/misc'
          label='Miscellaneous'
        />
      </div>

      <UpButton linkTo='/' />
    </div>
  );
}

export default Paintings;
